import { render } from "./Vas.vue?vue&type=template&id=33ca672d&scoped=true"
import script from "./Vas.vue?vue&type=script&lang=js"
export * from "./Vas.vue?vue&type=script&lang=js"

import "./Vas.vue?vue&type=style&index=0&id=33ca672d&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ca672d"]])

export default __exports__